module.exports = __webpack_public_path__ + "media/images/product-banners/supermodeller-67a30a6f3557d21add013b5ed621da37.svg";